import { render, staticRenderFns } from "./ed-block-item-add.component.vue?vue&type=template&id=6471bb29&scoped=true&"
import script from "./ed-block-item-add.component.ts?vue&type=script&lang=ts&"
export * from "./ed-block-item-add.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-block-item-add.component.scss?vue&type=style&index=0&id=6471bb29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6471bb29",
  null
  
)

export default component.exports